// extracted by mini-css-extract-plugin
export default {"button":"Buttons_button__5bpSL","button2":"Buttons_button2__Mr-TP","buttonDisabled":"Buttons_buttonDisabled__evcrV","button3":"Buttons_button3__Ojo5Q","logo":"Buttons_logo__bGn2x"};